import React from 'react'
import classNames from 'classnames'
import Helmet from 'react-helmet'
import RegistrationLayout from 'Src/components/Layouts/RegistrationLayout'
import RegistrationForm from 'Src/components/Registration/RegistrationForm'
import RegistrationPageFooter from 'Src/components/Registration/RegistrationPageFooter'
import RegistrationPageHeader from 'Src/components/Registration/RegistrationPageHeader'
import PlaceholderSpinner from 'Src/components/Spinners/PlaceholderSpinner'
import {useFrameContext} from 'Src/contexts/FrameContext'
import {getIsProduction, transString} from 'Src/utilities/Helpers'
import {TOKEN_STATE} from 'Src/utilities/useToken'

const Registration = () => {
  const {tokenState} = useFrameContext()

  if (tokenState === TOKEN_STATE.LOADING) {
    return <PlaceholderSpinner className={classNames({'tw-bg-purple-500': !getIsProduction()})} />
  }

  return (
    <>
      <Helmet>
        <title>{transString('reg.document_title')}</title>
      </Helmet>
      <RegistrationLayout>
        <RegistrationPageHeader />
        <RegistrationForm />
        <RegistrationPageFooter />
      </RegistrationLayout>
    </>
  )
}

export default Registration
